<template>
  <div id="app" class="toolkit">
    <div class="wrapper">
      <Header />
      <router-view />
    </div>
    <Footer />
  </div>
</template>

<script>
/* eslint-disable */
import Footer from '@/components/Footer'
import Header from '@/components/Header'
export default {
  name: 'App',
  components: {
    Footer,
    Header
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue